(() => {
  const previousResponses = {};
  const previousResponseTimers = {};
  const language = document.documentElement.getAttribute('lang') || 'de';
  let callbackCount = 0;

  function getFormData(elem) {
    if (!window.FormData) {
      window.console.error('Your browser does not support the FormData API');
      return false;
    }
    return new FormData(elem);
  }

  function process(xhr) {
    return {
      text: () => Promise.resolve(xhr.responseText),
      json: () => Promise.resolve(xhr.responseText).then((text) => (window.swinger.json.parse ? window.swinger.json.parse(text) : JSON.parse(text))),
      xml: () => Promise.resolve(xhr.responseXML),
      response: () => Promise.resolve(xhr.response), // blob
      status: xhr.status,
      request: xhr,
    };
  }

  function jsonp(url, options) {
    return new Promise((resolve) => {
      const id = `swinger_jsonp_cb_${callbackCount}`;
      const head = document.querySelector('head');
      const script = document.createElement('script');
      const callbackParamName = typeof options.jsonp === 'string' ? options.jsonp : 'callback';

      script.src = `${url + (url.indexOf('?') === -1 ? '?' : '&')}${callbackParamName}=${id}`;
      head.appendChild(script);

      window[id] = (data) => {
        head.removeChild(script);
        resolve(process({
          response: data,
          responseText: data,
          status: 200,
          jsonpCallbackName: id,
        }));
        delete window[id];
      };

      callbackCount += 1;
    });
  }

  function xhr(url, options) {
    // eslint-disable-next-line no-unused-vars
    const withCredentials = self.origin
      && self.origin.indexOf('localhost') === -1
      && self.origin.indexOf(':3000') === -1
      && self.origin.indexOf('https://x-templates') === -1;

    if (withCredentials) {
      options.credentials = 'include';
    }

    if (options.body) {
      try {
        JSON.parse(options.body);
        options.headers = { 'content-type': 'application/json;charset=UTF-8', ...options.headers };
      } catch (e) {
        // noop
      }
    }

    if (options.method.toUpperCase() !== 'GET') {
      options.headers = { 'x-requested-with': 'XMLHttpRequest', ...options.headers };
      window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:show');
    }

    options.headers = { 'Accept-Language': language, ...options.headers };

    if (options.form && options.form.nodeName === 'FORM') {
      options.body = getFormData(options.form);
    }

    if (!options.method || options.method.toUpperCase() === 'GET') {
      const previousResponse = previousResponses[url];

      /* eslint-disable */
      if (previousResponse) {
        return previousResponse.then(result => JSON.parse(JSON.stringify(result)));
      }
    }

    const response = new Promise((resolve, reject) => {
      fetch(url, options)
        .then((result) => {
          if (!result.ok) {
            if (options.method.toUpperCase() !== 'GET') {
              window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
            }
            console.error('Response was not okay: ' + url);

            result
              .json()
              .then((result) => {
                switch (true) {
                  default:
                    reject();
                    break;

                  case !!result.errmsg && Array.isArray(result.errmsg):
                    reject(result.errmsg[0]);
                    break;

                  case !!result.errmsg && !Array.isArray(result.errmsg):
                    reject(result.errmsg);
                    break;
                }
              })
              .catch(() => {
                result.text()
                  .then(reject)
                  .catch(() => {
                    reject();
                  });
              });
            return;
          }

          if (options.method.toUpperCase() !== 'GET') {
            window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
            resolve(result);
            return;
          }

          let decodeMethod = 'json';

          if (!result.headers.get('Content-Type')) {
            if (options.method.toUpperCase() !== 'GET') {
              window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
            }
            console.error('Response was of no valid type: ' + url);
            reject();
            return;
          }

          if (result.headers.get('Content-Type').indexOf('application/json') === -1) {
            decodeMethod = 'text';
          }

          result[decodeMethod]()
            .then((result) => {
              resolve(result);
            })
            .catch((e) => {
              if (options.method.toUpperCase() !== 'GET') {
                window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
              }
              console.error(e);
              reject(e);
            });
        })
        .catch((e) => {
          if (options.method.toUpperCase() !== 'GET') {
            window.swinger.eventHub.trigger(document, 'swinger-loading-indicator:hide');
          }
          console.error(`Error fetching ${url}:`);
          console.error(e);
          reject(e);
        });
    });

    if (!options.method || options.method.toUpperCase() === 'GET') {
      previousResponses[url] = response;
    }

    response
      .then(() => {
        window.clearTimeout(previousResponseTimers[url]);
        previousResponseTimers[url] = window.setTimeout(() => {
          delete previousResponses[url];
        }, 1000);
      })
      .catch(() => {
        window.clearTimeout(previousResponseTimers[url]);
        previousResponseTimers[url] = window.setTimeout(() => {
          delete previousResponses[url];
        }, 1000);
      });

    return response;
  }

  window.swinger = {
    ...window.swinger,
    getFormData,
    ajax(url, requestOptions = {}) {
      if (typeof window.URL === 'function') {
        try {
          const parsedUrl = new URL(url, window.location);

          if (parsedUrl.protocol === 'file:') {
            return Promise.reject('Ajax requests are not supported with local files');
          }
        } catch (e) {
          return Promise.reject('Invalid URL given');
        }
      }

      const defaultOptions = {
        method: 'get',
        body: null,
        callback: () => {
        },
        jsonp: false,
        addNoCache: false,
      };

      const options = {...defaultOptions, ...requestOptions};

      if (options.addNoCache) {
        url = `${`${url + (url.indexOf('?') === -1 ? '?' : '&')}nocache=${(new Date()).getTime()}`}`;
      }

      if (options.jsonp) {
        return jsonp(url, options);
      }

      return xhr(url, options);
    },
  };
})();
